export const REPORT_LINECHART = 'linechart';
export const REPORT_BARCHART = 'barchart';
export const REPORT_BARCHART_NAVIGATE = 'barchart_navigate';
export const REPORT_BARCHART_ALTERNATE = 'barchart_alternate';
export const REPORT_TABLE = 'table';
